import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=0647783b&"
import script from "./ModalNotification.vue?vue&type=script&lang=js&"
export * from "./ModalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports